(function () {

  'use strict';

  eclipseApp.directive('rgUsageDialRealtime', function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'modules/core/views/usage-dial-realtime.html',
      scope: {
        type: '@',
        dialData : '=',
        selectedBan : '=',
        selectedCTN :'=',
        initiatePricePlanChange : '=',
        dialEligible: '='
      },
      controller: 'usageDialRealtimeCtrl'

    };
  });

})();

